// constants/userTypes.js

/**
 * Defines the valid user type categories in the system.
 * These correspond to the ENUM values in the 'user_type' column of the 'users' table.
 */
const USER_TYPE_DEFINITIONS = {
    INTERNAL_STAFF: 'internal_staff',
    PARTNER: 'partner',
    CUSTOMER: 'customer',
};

const USER_TYPE_VALUES = Object.values(USER_TYPE_DEFINITIONS);

/**
 * Human-readable labels for each user type
 */
const USER_TYPE_LABELS = {
    [USER_TYPE_DEFINITIONS.INTERNAL_STAFF]: 'Internal Staff',
    [USER_TYPE_DEFINITIONS.PARTNER]: 'Partner',
    [USER_TYPE_DEFINITIONS.CUSTOMER]: 'Customer',
};

/**
 * Validates if a given user type is allowed
 */
const isValidUserType = (userType) => USER_TYPE_VALUES.includes(userType);

module.exports = {
    USER_TYPE_DEFINITIONS,
    USER_TYPE_VALUES,
    USER_TYPE_LABELS,
    isValidUserType
};